import React, { useMemo, useState, useCallback } from 'react';
import { PaymentConfirmStep, PaymentConfirmationStep, PaymentInformationStep } from '../steps/Steps';
import MakePayment from '../MakePayment';
import PolicySelection from './PolicySelection';
import numeral from 'numeral';

const AccountPayment = (props) => {
	const [selectedPolicies, setSelectedPolicies] = useState([]);
	const { policies, bypassAmountChecks, isFuture, maskErrorMessage, isMasked, isMaskFailed, selectedPolicyNumber, onPolicyNumberSelected, onPolicySelectionOpen, payment, isOneView = false } = props;
	const { settings } = payment;
	const [error, setError] = useState();

	const hasBalance = useMemo(
		() =>
			(policies || [])
				.map((p) => (isFuture ? p.futurePolicy : p))
				.filter((p) => p != null)
				.some((p) => p.paymentInfo.outstandingBalance > 0 || p.paymentInfo.payInFullAmount > 0) || isOneView
			,
		[isFuture, policies, isOneView]
	);

	const policySelectionStep = useCallback(() => {
		return {
			subheader: 'Select Account/Policies',
			content: <PolicySelection policies={policies} onPolicySelectionChange={setSelectedPolicies} onPolicySelectionOpen={onPolicySelectionOpen} selectedPolicies={selectedPolicies} hasBalance={hasBalance} bypassAmountChecks={bypassAmountChecks} isFuture={isFuture} selectedPolicyNumber={selectedPolicyNumber} onPolicyNumberSelected={onPolicyNumberSelected} />,
			getErrors: () => {
				const errors = [];
				setError(null);
				if ((hasBalance || bypassAmountChecks) && selectedPolicies.length === 0) {
					errors.push('At least one policy must be selected');
				}

				const payments = selectedPolicies.map((policy) => +policy.amount);
				const total = payments.length !== 0 ? payments.reduce((a, b) => a + b) : 0;

				if (total <= 0) {
					errors.push('Total must be greater than $0.00');
				}


				if (payments.some((a) => a > settings.maximumVendorPaymentAmount)) {
					setError(`Payments greater than ${numeral(settings.maximumVendorPaymentAmount).format('$0,0.00')} cannot be made online.  Please contact customer service at 800.477.1660.`);
					errors.push(`Must be less than ${numeral(settings.maximumVendorPaymentAmount).format('$0,0.00')}`);
				}

				const hasErrors = selectedPolicies.some((policy) => {
					if (!policy.isPartOfAccountBill && policy.outstandingBalance > 0) {
						if (policy.amount < policy.outstandingBalance) {
							return true;
						}
					} else if (policy.isPartOfAccountBill && policy.accountOutstandingBalance > 0) {
						if (policy.amount < policy.accountOutstandingBalance) {
							return true;
						}
					} else if (policy.amount < 10) {
						return true;
					}

					return false;
				});

				if (hasErrors && !bypassAmountChecks) {
					errors.push('Invalid amounts');
				}

				return errors;
			},
			alternateContinueButtonText: !hasBalance ? 'Ok' : null,
			onContinue: !(hasBalance || bypassAmountChecks) ? () => props.onClose() : null,
			showBack: () => false,
		};
	}, [bypassAmountChecks, hasBalance, isFuture, onPolicyNumberSelected, onPolicySelectionOpen, settings, policies, props, selectedPolicies, selectedPolicyNumber]);

	const steps = useMemo(() => [policySelectionStep, PaymentInformationStep, PaymentConfirmStep, PaymentConfirmationStep], [policySelectionStep]);

	const onReset = useCallback(() => {
		setSelectedPolicies([]);
	}, []);

	return <MakePayment {...props} error={error} steps={steps} onReset={onReset} policies={selectedPolicies} maskErrorMessage={maskErrorMessage} isMasked={isMasked} isMaskFailed={isMaskFailed} hasBalance={hasBalance} />;
};

export default AccountPayment;
